import { render, staticRenderFns } from "./service-category-edit.vue?vue&type=template&id=0f821ce8&scoped=true"
import script from "./service-category-edit.vue?vue&type=script&lang=ts"
export * from "./service-category-edit.vue?vue&type=script&lang=ts"
import style0 from "./service-category-edit.vue?vue&type=style&index=0&id=0f821ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f821ce8",
  null
  
)

export default component.exports